import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import { Col, Row, Input, Button } from "reactstrap";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import TableDropdown from "./tableDropdown";
import moment from "moment";
const ApplicationsTable = ({
  tableData,
  defaultSorted,
  setToggleModal,
  setDataModal,
  forceUpdate,
  setDeleteBody,
  searchQuery,
}) => {

  const { ExportCSVButton } = CSVExport;

  const statusFormatter = cell =>
    cell === "In Review" ? (
      <Button className="btn-status" disabled color="warning">
        In Review
      </Button>
    ) : cell === "Accepted" ? (
      <Button className="btn-status" disabled color="success">
        Accepted
      </Button>
    ) : cell === "Rejected" ? (
      <Button className="btn-status" disabled color="danger">
        Rejected
      </Button>
    ) : null;

  
    const dateFormatter = (cell, row) => {
      return (
        moment(cell).format('YYYY-MM-DD')
      );
    };

  const columns = [
    {
      dataField: "label_project_name",
      text: "Label / Project Name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      }
    },
    {
      dataField: "label_project_stats",
      text: "Project Status",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      }
    },
    {
      dataField: "interested_in",
      text: "Interested In",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      }
    },
    {
      dataField: "created",
      text: "Date Submitted",
      formatter: dateFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      }
    },
    {
        dataField: "application_status",
        text: "Status",
        formatter: statusFormatter,
        csvFormatter: statusFormatter,
        sort: false,
        csvExport: true,
        headerStyle: (colum, colIndex) => {
          return { width: "80px" };
        }
    }
  ];


  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "name" || sortField === "spotify_identifier" || sortField === "apple_identifier") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
    if(sortField === "owner") {
      searchQuery.setOrdering({order: ascDesc, name: "created_by__username", sort: "created_by__username"});
    }
  }

  return (
    <>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
        search={{
          searchFormatted: true
        }}
        exportCSV={ {
          fileName: 'artists.csv',
        } }
      >
        {props => (
          <div>
            <Row>
              <Col>
                {/* <div className="customSearch">
                  <Input placeholder="Search..." value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
                </div> */}
              </Col>
              <Col>
                {/* <div className="flexEndContainer">
                  <ExportCSVButton
                    className="btn btn-outline-info"
                    {...props.csvProps}
                  >
                    Export CSV
                  </ExportCSVButton>
                </div> */}
              </Col>
            </Row>

            <BootstrapTable
              {...props.baseProps}
              bordered={ false }
              defaultSorted={defaultSorted}
              remote={ { sort: false } }
              onTableChange={handleTableChange}
            />
          </div>
        )}
      </ToolkitProvider>
    </>
  );
};

export default ApplicationsTable;
